import React from 'react';
import { Modal } from 'antd';
import styles from './FounderLetterModal.module.scss';

const FounderLetterModal = ({ isOpen, onClose }) => (
    <Modal
        open={isOpen}
        onCancel={onClose}
        footer={null}
        width={800}
        centered
        className={styles.earlyAccessModal}
    >
        <div className={styles.modalContent}>
            <div className={styles.modalHeader}>
                <h3 className={styles.modalTitle}>Early Access Details</h3>
            </div>

            <div className={styles.modalBody}>
                <div className={styles.section}>
                    <h4 className={styles.sectionTitle}>How long will this be in Early Access?</h4>
                    <p className={styles.text}>
                        We already have a date in mind but there are a couple things holding us back from
                        announcing it. That said, we can ensure our time and commitments are being put into
                        polishing this product to the best of our extent. We understand the value of education
                        and how a product like this can influence people.
                    </p>
                </div>

                <div className={styles.section}>
                    <h4 className={styles.sectionTitle}>What's the current state and full launch plan?</h4>
                    <p className={styles.text}>
                        We are launching Prepal in phases, each focusing on different core aspects:
                    </p>

                    <div className={styles.buildPhase}>
                        <h5 className={styles.buildTitle}>Build 0.1 (Current)</h5>
                        <ul className={styles.featureList}>
                            <li>1200+ practice questions</li>
                            <li>AI explanation and conversations</li>
                            <li>Adaptive testing environment</li>
                            <li>Basic score tracking and progress</li>
                        </ul>
                    </div>

                    <div className={styles.buildPhase}>
                        <h5 className={styles.buildTitle}>Build 0.2</h5>
                        <ul className={styles.featureList}>
                            <li>Full-length diagnostic tests</li>
                            <li>Progressive hints for each question type</li>
                            <li>Simulate growth from start to goal</li>
                            <li>Set test dates and dream goals</li>
                        </ul>
                    </div>

                    <div className={styles.buildPhase}>
                        <h5 className={styles.buildTitle}>Build 0.3</h5>
                        <ul className={styles.featureList}>
                            <li>Personalized study plan generation</li>
                            <li>Live updating study plans</li>
                            <li>Weekly reports to parents and guardians</li>
                        </ul>
                    </div>

                    <div className={styles.buildPhase}>
                        <h5 className={styles.buildTitle}>Final Launch</h5>
                        <ul className={styles.featureList}>
                            <li>Curated tutor marketplace</li>
                            <li>Tutors briefed with your study plan</li>
                            <li>Polished features &amp; experience</li>
                        </ul>
                    </div>
                </div>

                <div className={styles.section}>
                    <h4 className={styles.sectionTitle}>What You Get as an Early Adopter</h4>
                    <div className={styles.benefitsList}>
                        <div className={styles.benefit}>
                            <span className={styles.benefitIcon}>💰</span>
                            <div>
                                <h5 className={styles.benefitTitle}>Special Pricing</h5>
                                <p className={styles.benefitText}>
                                    One-time deal instead of subscription. At launch, we'll send an offer
                                    for our final product or a referral link to transfer this offer.
                                </p>
                            </div>
                        </div>
                        <div className={styles.benefit}>
                            <span className={styles.benefitIcon}>🎯</span>
                            <div>
                                <h5 className={styles.benefitTitle}>Priority Support</h5>
                                <p className={styles.benefitText}>
                                    Your feedback and technical tickets will be prioritized directly by
                                    our development team.
                                </p>
                            </div>
                        </div>
                        <div className={styles.benefit}>
                            <span className={styles.benefitIcon}>✨</span>
                            <div>
                                <h5 className={styles.benefitTitle}>Feature Influence</h5>
                                <p className={styles.benefitText}>
                                    You'll have direct input via our community and emails on which
                                    features we prioritize next.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                <div className={styles.closing}>
                    <p className={styles.text}>
                        Your investment and support is not just a payment; it's a vote of confidence
                        that helps us accelerate development and refine Prepal for everyone.
                    </p>
                    <p className={styles.signature}>
                        Sincerely,<br />
                        <span className={styles.team}>Prepal Team</span>
                    </p>
                </div>
            </div>
        </div>
    </Modal>
);

export default FounderLetterModal;
